import "../styles/index.scss";
import { ReceiptProcessor} from './RecieptUploader';
const a = new ReceiptProcessor();
a.mount()
export { ReceiptProcessor };
